import { action, makeAutoObservable, observable } from "mobx";

export interface Item {
    id: string;
    name: string;
}

export default class TestStore {

    @observable
    list: Item[];
 
    constructor() {
        this.list = [];
        makeAutoObservable(this);
    }

    @action
    setList = (list: any) => {
        this.list = list; 
        console.log("In setList: " + this.list);
    }

}